module.exports = __webpack_public_path__ + "static/media/story-20.c4415e73.jpg";